"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var Backbone = require('dibs-backbone');
var PublicationAttribute = require('bunsen/models/inventory/PublicationAttribute');
var PublicationAttributeValues = require('bunsen/collections/inventory/PublicationAttributeValues');


var PublicationAttributeValueWrapper = SoaModel.extend({

    relations: [{
        type: Backbone.One,
        key: 'attribute',
        relatedModel: PublicationAttribute
    }, {
        type: Backbone.Many,
        key: 'value',
        collectionType: PublicationAttributeValues
    }],

    getValues: function () {
        return this.get('value');
    }
});

module.exports = PublicationAttributeValueWrapper;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/PublicationAttributeValueWrapper.js
// module id = 2652
// module chunks = 63